<template>
    <div>

 
            <div class="row">

<div class="col-md-12 col-sm-12" v-for="item in GeneralAdvice" v-bind:Key="item.StudentID">
  <div class="panal mt-20" v-if="item.MessageType == 'Need Advisor'">
           <div class="panal-header">Send to Advisor</div>
          <div class="panal-body">

          <b-alert show>
                 <h1>{{item.MessageType}}</h1>
             
             <h6>Advice  Description </h6>
                  {{item.Advice}}
          </b-alert>
            <div class="clearfix"></div>
          </div>
        </div>

         <div class="panal mt-20" v-else>
          
           <div class="panal-header">General Advice</div>
            <div v-for="item2 in item.Advice" v-bind:Key="item2.StudentID">
              <div class="panal-body">
         
          <b-alert show >
                 <h1>{{item.MessageType}}</h1>
             
             <h6>Advice  Description </h6>
                  {{item.Advice}}
          </b-alert>
            <div class="clearfix"></div>
          </div>
        </div>
         </div>
            <div class="clearfix"></div>
      



        
        <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>
    </div>





</div>
</div>
</template>





<script>
    import studentData from '../../services/student/studentDataServices';
    export default {
        name: 'GeneralAdvice',
        data(){
            return{
                GeneralAdvice: [], 
                message:'',
                isLoading : true, 
                successful : false,
               empty : true,
            }
        }, computed:{
           currenUser(){
            return  this.$store.state.auth.user
          }
       },
       mounted(){
         //this.currenUser.StudentID
         // 131
           studentData.GetAcademicAdvice(this.currenUser.StudentID).then(Response =>{
               this.isLoading = false ;
               this.GeneralAdvice = Response.data
               this.empty = false;
                // eslint-disable-next-line no-console
                  // console.log(Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 this.empty = true;
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
                this.successful = false
            }) 
       },
       

    };
</script>










<style >
h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #50BD77;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}


</style>